module.exports = require('../dist/compat/array/xor.js').xor;
